import { render } from "./pieChartBase.vue?vue&type=template&id=4fc52bc7&ts=true"
import script from "./pieChartBase.vue?vue&type=script&lang=ts"
export * from "./pieChartBase.vue?vue&type=script&lang=ts"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__